import { sendRequest } from "../../../../api/rootApi";
import HttpRequest from "../../../GlobalAddDealModalV3/helpers/HttpRequest";


const tenantUrl=`${process.env.REACT_APP_PYPEPRO_TENANT_BACKEND_SERVER}/api/v1`;
const calendarUrl = `${process.env.REACT_APP_BACKEND_URL}/${process.env.REACT_APP_API_VERSION}/calendar`

const endpoints = {
    userActivities: `${tenantUrl}/dashboard/user-activities`,
    userInboxData: `${tenantUrl}/dashboard/inbox-data`,
    userNotifications: `${tenantUrl}/dashboard/notifications`,
    markAsDone: `${calendarUrl}/activity-mark-as-done`,
    deleteActivityForCalendar: `${calendarUrl}/delete-activity-for-calendar`,
};

export const getUserActivities = (payload) => {
    return HttpRequest.get(endpoints.userActivities, payload);
}
export const getUserInbox = (payload) => {
    return HttpRequest.get(endpoints.userInboxData, payload);
}

export const getUserNotifications = (payload) => {
    return HttpRequest.get(endpoints.userNotifications, payload);
}

export const markAsDone = async (payload) => {
    return sendRequest("post", endpoints.markAsDone, payload);
}

export const deleteActivityForCalendar = async (payload) => {
    return sendRequest("post", endpoints.deleteActivityForCalendar, payload);
}